<template>
  <img
    v-if="picture && lazy && !with_authors"
    v-lazy="
      picture
        ? `${
            !big ? thumbnail(picture.thumbnail_path, size) : picture.public_path
          }?api_token=${token}`
        : ''
    "
    @load="$emit('rawLoad', $event)"
  /><img
    v-else-if="picture && !with_authors"
    :src="
      picture
        ? `${
            !big ? thumbnail(picture.thumbnail_path, size) : picture.public_path
          }?api_token=${token}`
        : ''
    "
    @load="$emit('rawLoad', $event)"
  />
  <div
    v-else-if="picture && lazy && with_authors"
    style="position:relative;width: 100%;height:100%;"
  >
    <img
      v-lazy="
        picture
          ? `${
              !big
                ? thumbnail(picture.thumbnail_path, size)
                : picture.public_path
            }?api_token=${token}`
          : ''
      "
      @load="$emit('rawLoad', $event)"
    />
    <div
      class="ApiPicture__authors"
      style="display:block;z-index:9;position:absolute;top:-4px; right: 0;padding-bottom: 2px;"
    >
      {{ picture.authors.length }} auteur(s) :
      <ul>
        <li v-for="author in picture.authors"
            :key="author.uuid">{{ author.name }}</li>
      </ul>
    </div>
  </div>
  <div
    v-else-if="picture && with_authors"
    style="position:relative;width: 100%;height:100%;"
  >
    <img
      :src="
        picture
          ? `${
              !big
                ? thumbnail(picture.thumbnail_path, size)
                : picture.public_path
            }?api_token=${token}`
          : ''
      "
      @load="$emit('rawLoad', $event)"
    />
    <div
      v-if="picture && with_authors"
      class="ApiPicture__authors"
      style="display:block;z-index:9;position:absolute;top:-4px; right: 0;padding-bottom: 2px;"
    >
      {{ picture.authors.length }} auteur(s) :
      <ul>
        <li v-for="author in picture.authors"
            :key="author.uuid">{{ author.name }}</li>
      </ul>
    </div>
    <div v-if="picture && with_dl" class="ApiPicture__dl" style="display:block;z-index:9;position:absolute;bottom:-4px;right: 0;">
      <button class="button is-small"><a :href="picture.public_path">&darr;</a></button>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/pictures";

export default {
  name: "ApiPicture",
  props: {
    pictureId: {
      required: true
    },
    big: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    update: {
      type: Boolean,
      default: false
    },
    with_authors: {
      type: Boolean,
      default: false
    },
    with_dl: {
      type: Boolean,
      default: true,
    },
    picture_class: {},
    size: {
      type: Number,
      required: false
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      picture: null
    };
  },
  methods: {
    async getPicture() {
      if (typeof this.pictureId !== "undefined" && this.pictureId !== null) {
        this.picture = await this.$store.dispatch(
          this.with_authors ? t.GET_PICTURE_WITH_AUTHORS : t.GET_PICTURE,
          this.pictureId
          );
      }
    },
    thumbnail(path, size = null) {
      if (!size) return path;
      return path.replace("medium", size);
    }
  },
  computed: {
    token() {
      return this.$store.state.user.token;
    }
  },
  mounted() {
    this.getPicture();
  },
  watch: {
    picture(val) {
      if (val) {
        this.$emit("load", val);
      }
    },
    update() {
      this.$nextTick(() => {
        this.getPicture();
      });
    },
    pictureId() {
      this.$nextTick(() => {
        this.getPicture();
      });
    }
  }
};
</script>

<style lang="scss">
img[lazy="loaded"] {
  opacity: 0;
  animation-name: fadein;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-timing-function: ease-out;

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}

  .ApiPicture__authors {
    background: white;
    font-size: 9px;
    padding: 4px;
  }
</style>
